<form [formGroup]="addAccountForm" class="tw-relative">
  <div>

    <ion-icon (click)="closeForm()" name="close-circle" class="close-form"></ion-icon>

    <p class="tw-text-[15px] tw-pt-[55px]">
      To prevent funding delays, please verify that your Routing Number is in correct.
    </p>

    <p class="tw-text-[15px] tw-mt-[15px]">
      <span class="tw-font-bold">Click here: </span><br>
      <span class="tw-text-[13px]">
        <a
          href="https://www.frbservices.org/EPaymentsDirectory/search.html"
          target="_blank"
          clas="tw-underline"
        >
          https://www.frbservices.org/EPaymentsDirectory/search.html
        </a>
      </span>
    </p>

    <p class="tw-text-[15px] tw-mt-[15px]">
      <span class="tw-font-bold">NOTICE:</span> Pre-loaded debit cards not accepted
    </p>

    <div class="account-row tw-relative tw-mt-[25px]">
      <!-- Message section -->
      <span class="tw-absolute tw-top-[-18px] tw-right-[0px] tw-h-[18px] tw-block tw-pt-[2px]">

        <!-- Required -->
        <span
          class="tw-block tw-text-right tw-text-xs tw-text-[#D83A19]"
          *ngIf="formVal['bankName'] && formVal['bankName'].hasError('required')
            && (formVal['bankName'].touched || formVal['bankName'].dirty)"
        >
          {{ 'Required Bank Name' }}
        </span>
      </span>

      <p class="tw-text-[16px]">Bank Name</p>
      <input
        formControlName="bankName"
        id="bankName"
        type="text"
        class="tw-h-[38px] tw-text-[16px] tw-text-[#645858]"
      />
    </div>

    <div class="account-row tw-relative tw-mt-[22px]">
      <!-- Message section -->
      <span class="tw-absolute tw-top-[-18px] tw-right-[0px] tw-h-[18px] tw-block tw-pt-[2px]">

        <!-- Required -->
        <span
          class="tw-block tw-text-right tw-text-xs tw-text-[#D83A19]"
          *ngIf="formVal['routingName']
            && (formVal['routingName']?.errors
                || addAccountForm.get('routingName')?.hasError('invalidCharacters')
                || addAccountForm.get('routingName')?.hasError('minlength')
                || addAccountForm.get('routingName')?.hasError('maxlength')
              )
            && (formVal['routingName'].touched || formVal['routingName'].dirty)"
        >
          {{
            addAccountForm.get('routingName')?.hasError('invalidCharacters')
              ? 'Please enter a valid number.'
              : addAccountForm.get('routingName')?.hasError('minlength') ||
                addAccountForm.get('routingName')?.hasError('maxlength')
                ? 'Please enter 9 digits.'
                : 'Required Routing Number.'
          }}
        </span>


      </span>

      <p class="tw-text-[16px]">Routing Number</p>
      <input
        formControlName="routingName"
        inputmode="numeric"
        id="routingName"
        type="text"
        class="tw-h-[38px] tw-text-[16px] tw-text-[#645858]"
      />
    </div>

    <div class="account-row tw-relative tw-mt-[22px]">
      <!-- Message section -->
      <span class="tw-absolute tw-top-[-18px] tw-right-[0px] tw-h-[18px] tw-block tw-pt-[2px]">

        <!-- Required -->
        <span
          class="tw-block tw-text-right tw-text-xs tw-text-[#D83A19]"
          *ngIf="formVal['accountType'] && formVal['accountType'].hasError('required')
            && (formVal['accountType'].touched || formVal['accountType'].dirty)"
        >
          {{ 'Required Account Type' }}
        </span>
      </span>

      <p class="tw-text-[16px]">Account Type</p>
      <select
        formControlName="accountType"
        id="accountType"
      >
        <option value="PC" selected="true">Checking</option>
        <option value="PS">Savings</option>
      </select>
      <!-- <input
        formControlName="accountType"
        id="accountType"
        type="text"
        class="tw-h-[38px] tw-text-[16px] tw-text-[#645858]"
      /> -->
    </div>

    <div class="account-row tw-relative tw-mt-[22px]">
      <!-- Message section -->
      <span class="tw-absolute tw-top-[-18px] tw-right-[0px] tw-h-[18px] tw-block tw-pt-[2px]">

        <!-- Required -->
        <!-- *ngIf="formVal['accountNumber'] && formVal['accountNumber'].hasError('required')
            && (formVal['accountNumber'].touched || formVal['accountNumber'].dirty)" -->

        <!-- Required -->
        <span
          class="tw-block tw-text-right tw-text-xs tw-text-[#D83A19]"
          *ngIf="formVal['accountNumber']
            && (formVal['accountNumber']?.errors
                || addAccountForm.get('accountNumber')?.hasError('invalidCharacters')
                || addAccountForm.get('accountNumber')?.hasError('maxlength')
              )
            && (formVal['accountNumber'].touched || formVal['accountNumber'].dirty)"
        >
          {{
            addAccountForm.get('accountNumber')?.hasError('invalidCharacters')
              ? 'Please enter a valid number.'
              : addAccountForm.get('accountNumber')?.hasError('maxlength')
                ? 'Please enter no more than 20 characters.'
                : addAccountForm.get('accountNumber')?.hasError('minlength')
                  ? 'Please enter at least 6 characters.'
                  : 'Required Account Number.'
          }}
        </span>

      </span>

      <p class="tw-text-[16px]">Account Number</p>
      <input
        formControlName="accountNumber"
        inputmode="numeric"
        id="accountNumber"
        type="text"
        class="tw-h-[38px] tw-text-[16px] tw-text-[#645858]"
      />
    </div>

    <div class="account-container">
      <button
        (click)="addAccount()"
        [ngClass]="
          {'active': (tmsId && isAgree && !isProcessing && this.addAccountForm.valid)}
        "
        [disabled]="!tmsId || !isAgree || isProcessing || this.addAccountForm.invalid"
        class="add-account active tw-w-[100%] tw-h-[41px] tw-text-[16px] tw-mt-[35px]"
      >
        Add Account
      </button>
    </div>

    <img
      src="/assets/images/funding/payslip.png"
      class="tw-inline-block tw-mt-[35px]"
      width="100%"
    >

    <div class="tw-mt-[18px]">
      <p class="tw-text-center tw-text-[15px]">
        For your protection,
        <a href="https://amwager.com/" target="_blank" class="tw-underline">AmWager.com</a>
        will validate the name on your
        Bank account to the name on your wagering account
      </p>

      <p class="label tw-font-bold tw-text-[15px] tw-mt-[25px] tw-mr-[8px] tw-ml-[8px]">
        Terms and Conditions:
      </p>

      <p class="tw-text-[14px] tw-mt-[15px] tw-mr-[8px] tw-ml-[8px]">
        By accepting the terms of this Authorization Agreement, I authorize AmWest Entertainment
        "Merchant" to initiate Debits and Credits to my bank account at the Depository Financial
        Institution "Bank" as indicated by the Routing & Transit Number that I supplied, and Bank
        to pay Such Debit or Credit. This authorization is to remain in full force and effect until
        Merchant has received written notification from me of its termination in such time and in
        such manner to afford Merchant a reasonable opportunity to act. I agree that the electronic
        media record of my transactions held by Merchant shall be used as the final determination to
        resolve any dispute I may have. I understand it is my sole responsibility, if applicable, to
        report my financial information to my respective Government or Tax jurisdiction.
        I acknowledge that I have read all the information contained and agree to abide by all rules,
        terms, conditions and agreements and as amended from time to time.
      </p>
    </div>

    <div class="terms-and-condition-container tw-mt-[15px] tw-mr-[8px] tw-ml-[8px]">
      <ion-checkbox
        mode="md"
        [value]="isAgree"
        [checked]="isAgree"
        (ionChange)="toggleCheckbox()"
        id="termsAndCondition"
        class="active-limit tw-top-1 tw-mt-0 tw-mr-[4px] tw-mb-0">
      </ion-checkbox>
      <span
        (click)="toggleCheckbox()"
        class="agree tw-font-bold tw-text-[15px]"
      >
        I agree to the above terms
      </span>
    </div>

  </div>
</form>
